// Distribution feed (docs/API.md §6). Best-effort — the Download screen degrades to a
// marketing link when this is unavailable.

import { apiGet } from "@/lib/api";
import type { ReleasesLatest } from "@/lib/types";

export function getLatestRelease(signal?: AbortSignal): Promise<ReleasesLatest> {
  return apiGet<ReleasesLatest>("/releases/latest", { anonymous: true, signal });
}
